import { render, staticRenderFns } from "./Tenure.vue?vue&type=template&id=5d74a5fa"
import script from "./Tenure.vue?vue&type=script&lang=js"
export * from "./Tenure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports